import PropTypes from 'prop-types';

import Button from 'honeydew/Button';
import CancelPlanIcon from 'honeydew/icons/MyPlan/CancelPlanIcon';
import Modal from 'honeydew/Modal';
import useBrandLinks from 'hooks/useBrandLinks';
import { closeModal } from 'utils/globalUtils';

function CancelOrderInfoModal({ cancelOrderInfoModal, setCancelOrderInfoModal }) {
    const { accountHelp } = useBrandLinks();

    const closeCancelOrderInfoModal = () => {
        closeModal(setCancelOrderInfoModal);
    };

    return (
        <Modal open={cancelOrderInfoModal} onClose={closeCancelOrderInfoModal}>
            <div className="text-center md:p-40">
                <div className="mx-auto mb-10 w-[75px]">
                    <CancelPlanIcon />
                </div>
                <h2 className="text-heading-sm mb-20">We&apos;re packing your box!</h2>
                <div className="mx-auto max-w-[400px]">
                    <p className="pb-30 font-grotesk-bold">
                        Which means your order is no longer eligible for cancellation.
                    </p>
                    <p>
                        You can read more about how to manage your account{' '}
                        <a className="link" target="_blank" rel="noopener noreferrer" href={accountHelp}>
                            here
                        </a>
                        .
                    </p>
                </div>

                <div className="text-body-sm mx-auto mt-25 mb-15 md:w-[380px]">
                    <Button size="md" onClick={closeCancelOrderInfoModal}>
                        Close
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

CancelOrderInfoModal.propTypes = {
    cancelOrderInfoModal: PropTypes.bool.isRequired,
    setCancelOrderInfoModal: PropTypes.func.isRequired,
};

export default CancelOrderInfoModal;
